import { tokenStorage } from '@/lib/token-storage';
import { ProfileCard } from './ProfileCard';
import { ContactInformationCard } from './ContactInformationCard';
import { ChangePasswordCard } from './ChangePasswordCard';
import { TwoFactorCard } from './TwoFactorCard';
import { AppSettingsCard } from './AppSettingsCard';
import styles from './Information.module.css';

/**
 * Account → Information. Stacks the profile, security (password + 2FA), and app
 * settings sections — the new-design rebuild of the legacy ManageProfile /
 * ManagePassword / ManageMultiFactor / ManageAppSettings sections.
 */
export function AccountInformation() {
  // Change-password applies to accounts that HAVE a password: local (email/password)
  // and VNETWORK-ID (SSO, routed to the DataCentral change-password endpoint). Only
  // Google sign-in has no password, so the card is hidden for Google alone.
  const isGoogle = tokenStorage.authMethod === 'google';
  return (
    <div className={styles.stack}>
      <ProfileCard />
      <ContactInformationCard />
      {!isGoogle && <ChangePasswordCard />}
      <TwoFactorCard />
      <AppSettingsCard />
    </div>
  );
}
